var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalOcean(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0080FF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#0080FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Digital_coean"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,70v-9.7c8.5,0,15.4-6.9,15.3-15.4c0-1.9-0.4-3.8-1.1-5.6c-1.5-4-4.6-7.1-8.6-8.6 c-7.9-3.1-16.8,0.8-19.9,8.8c-0.7,1.8-1,3.6-1,5.5H40c0.1-13.9,11.4-25.1,25.3-25c2.6,0,5.2,0.4,7.7,1.3 c7.5,2.4,13.4,8.3,15.8,15.8c4.3,13.2-2.8,27.4-16,31.7C70.2,69.6,67.6,70,65,70L65,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65,50.7v9.7h-9.7v-9.7H65z M55.4,60.4v7.4h-7.4v-7.4L55.4,60.4z M48,60.4h-6.2v-6.2h6.2L48,60.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalOcean);
export default __webpack_public_path__ + "static/media/Digital-Ocean.ad952a3faafbb7853f2b0e5541a6c0a0.svg";
export { ForwardRef as ReactComponent };